import { useTranslation } from "react-i18next"

import AppErrorSVG from "./assets/app-error.svg?react"

export const AppError = () => {
    const { t } = useTranslation("gift_card")

    return (
        <div className="h-full flex flex-col justify-center items-center ">
            <AppErrorSVG />
            <div className="mb-4 font-bold text-[1.75rem] leading-9.5">
                {t("niki.gift_card.error.title")}
            </div>
            <div className="text-[#373737]">
                {t("niki.gift_card.error.content")}
            </div>
        </div>
    )
}
